import axios from "axios";

const instance = axios.create({
    baseURL: "https://api.themoviedb.org/3"
})

export default instance;

// https://api.themoviedb.org/3/discover/tv?api_key=1010446e581e9d82dc9a123d55f3d657&with_networks=213 